import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ValueField } from '../model/value-field';
import { DeviceType, getPhysicalDeviceTypes } from '../../vehicles/model/device-type';
import { RestService } from '../../shared/service/rest.service';
import { flatten, groupBy } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class FieldsService extends RestService {

  private fields: Fields;

  fetchAllFields(): Observable<ValueField[]> {
    return this.postAndExtract<ValueField>(ValueField, 'api/admin/fields/fetch');
  }

  getAllUserFields(): Observable<ValueField[]> {
    if (this.fields) {
      const lists = Object.values(this.fields);
      return of(flatten(lists));
    } else
      return this.loadUserFields().pipe(
        tap(fields => this.fields = groupBy(fields, 'deviceType'))
      );
  }

  getFieldsForType(deviceType: DeviceType): Observable<ValueField[]> {
    if (this.fields)
      return of(this.fields[deviceType] || []);
    else
      return this.getAllUserFields().pipe(map(() => this.fields[deviceType] || []));
  }

  resetPhysicalDeviceTypesNames(reset = false): Observable<string[]> {
    let observable: Observable<Fields>;
    if (reset) {
      this.fields = null;
      observable = this.getAllUserFields().pipe(map(() => this.fields));
    } else {
      if (this.fields)
        observable = of(this.fields);
      else
        observable = this.getAllUserFields().pipe(map(() => this.fields));
    }
    return observable.pipe(map(fields =>
      Object.keys(fields).filter(item => getPhysicalDeviceTypes().find(device => device == item))
    ));
  }

  getPhysicalDeviceTypesNames(): Observable<string[]> {
    return this.resetPhysicalDeviceTypesNames();
  }

  private loadUserFields(): Observable<ValueField[]> {
    return this.postAndExtract<ValueField>(ValueField, 'api/fields/fetch');
  }

}

interface Fields {
  [key: string]: ValueField[];
}
